import Switch from "react-switch";
import React, { useEffect, useState } from "react";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import TimeInput from "material-ui-time-picker";
import { datesBetween, daysBetween } from "../../../../function/dayBetween";
import { TextField } from "@material-ui/core";
import { useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


const TimeSlots = ({ formik, expType, prevCopyTimings, prevStartDate, prevEndDate, cloneData, ...props }) => {
    const history = useHistory();

    const edit = history.location.pathname.includes('edit') ? true : false;


    const restaurant = useSelector((state) => {
        return !isEmpty(state.onboarding.restaurantDetails) ? state.onboarding.restaurantDetails : {};
    });

    const onDayOpenCloseHandler = (day) => {
        let days = { ...formik.values.timings };
        days[day].open = !days[day].open;
        formik.setFieldValue('timings', days);
    }

    const addOnClick = (day) => {
        let newMultiple = {
            open: true,
            openingTime: new Date(2020, 1, 1, 8),
            closingTime: new Date(2020, 1, 1, 23),
            description: "",
        };
        let days = { ...formik.values.timings };
        days[day].multipleHours = [...days[day].multipleHours, newMultiple];
        formik.setFieldValue('timings', days);
    }

    const onRemoveTimings = (day, hours) => {
        let days = { ...formik.values.timings };
        days[day].multipleHours = days[day].multipleHours.filter(ele => ele.description !== hours.description);
        formik.setFieldValue('timings', days);
    }

    const onChangeDesc = (day, indx, event) => {
        let days = { ...formik.values.timings };
        days[day].multipleHours[indx].description = event.target.value;
        formik.setFieldValue('timings', days);
    }

    const onHourStatus = (day, indx) => {
        let days = { ...formik.values.timings };
        days[day].multipleHours[indx].open = !days[day].multipleHours[indx].open;
        formik.setFieldValue('timings', days);
    }

    const onChangeOpenCloseTime = (day, indx, time, type) => {
        let days = { ...formik.values.timings };
        days[day].multipleHours[indx][type] = new Date(time);
        formik.setFieldValue('timings', days);
    }

    const copyMultipleTimeFunction = (day, index) => {
        let days = { ...formik.values.timings };
        let multi = { ...days[day] };
        for (let i = index; i < days.days.length; i++) {
            days[days.days[i]] = JSON.parse(JSON.stringify(multi));
        }
        formik.setFieldValue('timings', days);
    }

    useEffect(() => {
        if(cloneData?.startDate === formik.values.startDate && cloneData?.endDate === formik.values.endDate){
            formik.setFieldValue('timings', cloneData?.timings);
        }else if (edit && (!prevStartDate?.current && !prevEndDate?.current)) {
            formik.setFieldValue('timings', formik.values.timings);
        } else if (formik.values.startDate && formik.values.endDate && (prevStartDate?.current !== formik.values.startDate || prevEndDate?.current !== formik.values.endDate)) {
            let dates = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Friday', 'Saturday'];
            if (expType === 'CURATED') {
                dates = datesBetween(formik.values.startDate, formik.values.endDate);
                dates = [... new Set(dates)];
            } else {
                dates = daysBetween(formik.values.startDate, formik.values.endDate);
                dates = [... new Set(dates)];
            }
            let newData = { days: dates };
            for (let date of dates) {
                let d = {
                    open: false,
                    multipleHours: [{
                        open: true,
                        openingTime: new Date(2020, 1, 1, 8),
                        closingTime: new Date(2020, 1, 1, 23),
                        description: "",
                    }]
                };
                newData = { ...newData, [date]: d }
            }
            formik.setFieldValue('timings', newData);
        }
    }, [formik.values.startDate, formik.values.endDate]);

    useEffect(() => {
        if (formik?.values?.copyTimings) {
            let days = { ...formik.values.timings };
            let newData = { days: days.days };
            if (restaurant.are_you_open_24_x_7) {
                for (let date of days?.days) {
                    let d = {
                        open: true,
                        multipleHours: [{
                            open: true,
                            openingTime: new Date(2023, 1, 1, 0, 0),
                            closingTime: new Date(2023, 1, 1, 23, 59, 59),
                            description: "All Day",
                        }]
                    };
                    newData = { ...newData, [date]: d }
                }
            } else {
                let et = expType === 'SPECIAL' ? false : true;
                for (let date of days.days) {
                    let day = et ? moment(date, 'DD-MM-YYYY').format('dddd').toLowerCase() : date.toLowerCase();
                    let d = {
                        open: restaurant[day]?.open,
                        multipleHours: restaurant[day]?.multipleHours,
                    };
                    d.multipleHours = d.multipleHours.map(ele => {
                        return {
                            open: ele.open,
                            description: ele.description,
                            openingTime: moment(ele.opening_time).toISOString(),
                            closingTime: moment(ele.closing_time).toISOString()
                        }
                    })
                    newData = { ...newData, [date]: d }
                }
            }
            formik.setFieldValue('timings', newData);
        } else if (prevCopyTimings?.current === true && !formik?.values?.copyTimings) {
            let newData = { days: formik.values.timings.days};
            for (let date of newData?.days) {
                let d = {
                    open: false,
                    multipleHours: [{
                        open: true,
                        openingTime: new Date(2020, 1, 1, 8),
                        closingTime: new Date(2020, 1, 1, 23),
                        description: "",
                    }]
                };
                newData = { ...newData, [date]: d }
            }
            formik.setFieldValue('timings', newData);
        }
    }, [formik?.values?.copyTimings])

    return (
        <div className="margin-new-multiple-hours mb-5">
            {formik.values?.timings?.days?.map((day, index) => (
                <React.Fragment key={index}>
                    <div className="standard-hours-main">
                        <div className="standard-hours-main-sectionone">
                            <Switch
                                checked={formik.values.timings[day].open}
                                onChange={() => onDayOpenCloseHandler(day)}
                                offColor="#E3E3E3"
                                onColor="#E3E3E3"
                                offHandleColor="#212121"
                                onHandleColor="#59F832"
                                handleDiameter={16}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                height={10}
                                width={27}
                                boxShadow="-2px 0px 5px #0000003B"
                                activeBoxShadow="-2px 0px 5px #0000003B"
                            />
                            <h5 className="f14-500 ml-2 text-uppercase">{day}</h5>
                        </div>
                        {formik.values.timings[day]?.open === true ? (
                            <div style={{ "marginLeft": "5rem" }}>
                                {formik.values.timings[day]?.multipleHours?.map((hours, indx) => (
                                    <div
                                        className="row mb-4 mt-3 standard-hours-main-sectiontwo"
                                        key={indx}
                                    >
                                        <div className="standard-hours-main-sectiontwo-insidetoggle">
                                            <Switch
                                                checked={hours.open}
                                                onChange={
                                                    () => onHourStatus(day, indx)
                                                }
                                                offColor="#E3E3E3"
                                                onColor="#E3E3E3"
                                                offHandleColor="#212121"
                                                onHandleColor="#59F832"
                                                handleDiameter={16}
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                height={10}
                                                width={27}
                                                boxShadow="-2px 0px 5px #0000003B"
                                                activeBoxShadow="-2px 0px 5px #0000003B"
                                                id="material-switch"
                                            />
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between m-4">
                                            <div>
                                                <TextField
                                                    id="hours"
                                                    label="Session Name"
                                                    type="text"
                                                    variant="outlined"
                                                    className={"w-100"}
                                                    name="hours"
                                                    onChange={(e) => onChangeDesc(day, indx, e)}
                                                    value={hours.description}
                                                />
                                            </div>
                                        </div>
                                        <div className="m-2 standard-hours-main-sectiontwo-insidetoggle standard-hours-main-sectionthree-multi justify-content-center">
                                            <TimeInput
                                                mode="12h"
                                                value={new Date(hours.openingTime)}
                                                onChange={(time) =>
                                                    onChangeOpenCloseTime(
                                                        day,
                                                        indx,
                                                        time,
                                                        "openingTime",
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className=" m-2 standard-hours-main-sectiontwo-insidetoggle standard-hours-main-sectionthree-multi justify-content-center not-display-inmobile">
                                            <div className="standard-hours-main-sectiontwo-text m-0">
                                                <div className="f11-400">to</div>
                                            </div>
                                        </div>
                                        <div className=" m-2 standard-hours-main-sectiontwo-insidetoggle standard-hours-main-sectionthree-multi justify-content-center">
                                            <TimeInput
                                                mode="12h"
                                                value={new Date(hours.closingTime)}
                                                onChange={(time) =>
                                                    onChangeOpenCloseTime(
                                                        day,
                                                        indx,
                                                        time,
                                                        "closingTime",
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="m-2 d-flex align-items-center justify-content-between">
                                            {formik.values.timings[day].multipleHours.length > 1 ? (
                                                <div className="restaurant_details_onboarding_minus_button p-0 justify-content-center">
                                                    <div
                                                        className="restaurant_details_onboarding_minus_button_box"
                                                        onClick={
                                                            () => onRemoveTimings(day, hours)
                                                        }
                                                    >
                                                        <i
                                                            className="fa fa-trash"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                ))}
                                <div className="col-4 p-0 pt-2 restaurant_details_onboarding_minus_button row">
                                    <div className="col">
                                        <AddButtonIconComponent
                                            buttonText="Add Another Slot"
                                            onClick={() => addOnClick(day)}
                                            fontIcon="fa fa-plus"
                                            colorCss="blue"
                                            type={"button"}
                                        />
                                    </div>
                                    {formik.values?.timings?.days.length - 1 !== index ? <div className="col">
                                        <AddButtonIconComponent
                                            buttonText="Copy Timing to Rest of the Days"
                                            onClick={
                                                () => copyMultipleTimeFunction(day, index)
                                            }
                                            fontIcon="fa fa-clone"
                                            colorCss="red"
                                            type={"button"}
                                        //
                                        />
                                    </div> : <></>}
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                </React.Fragment>
            ))}
        </div>
    )
}

export default TimeSlots;